import React from "react";
import "../assets/css/Spinner.css";

const LoadingSpinner = ()=>{
  return (
    <div className="spinner-container">
      <div className="loading-spinner">
      </div>
    </div>
  );
}

export default LoadingSpinner;